export default "__VITE_ASSET__jEEFWRe___ 120w, __VITE_ASSET__BKtbfOA___ 240w, __VITE_ASSET__CbpbYqAa__ 360w, __VITE_ASSET__B6hJS0dA__ 480w";